import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getAllStories } from "@cinch-nx/data-storyblok";
export var getStaticProps = function() {
    var _ref = _async_to_generator(function(param) {
        var _preview, preview, stories, customStories, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _preview = param.preview, preview = _preview === void 0 ? false : _preview;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getAllStories({
                            starts_with: "jargon",
                            version: preview ? "draft" : "published"
                        })
                    ];
                case 2:
                    stories = _state.sent().stories;
                    customStories = stories.map(function(story) {
                        return {
                            content: {
                                question: story.content.question,
                                summary: story.content.summary,
                                fullTerm: story.content.fullTerm,
                                keywords: story.content.keywords
                            },
                            slug: story.slug
                        };
                    });
                    return [
                        2,
                        {
                            props: {
                                stories: customStories,
                                preview: preview,
                                layoutProps: {
                                    showBorderRadius: true
                                }
                            },
                            revalidate: 60
                        }
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            notFound: true,
                            props: {
                                stories: [],
                                preview: preview,
                                layoutProps: {
                                    showBorderRadius: true
                                }
                            },
                            revalidate: 60
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getStaticProps(_) {
        return _ref.apply(this, arguments);
    };
}();
